module.exports = __webpack_public_path__ + "static/media/bt.c0704dc6.png";